import { useEffect } from 'react';
import { useSetAtom } from 'jotai';

import ComingSoonSvg from './assets/coming-soon.svg?react';
import InstructionsComingSoon from './assets/instructions.svg?react';

import { emptyLayoutAtom } from '@/state';

import styles from './coming-soon.module.scss';

export const ComingSoon = (props: ComingSoonProps) => {
  const { slug } = props;

  const setEmptyLayout = useSetAtom(emptyLayoutAtom);

  useEffect(() => {
    setEmptyLayout(false);
  }, []);

  return (
    <div className={styles.comingSoonHolder} data-testid={slug}>
      {slug === 'instructions' ? <InstructionsComingSoon /> : <ComingSoonSvg />}
    </div>
  );
};

export interface ComingSoonProps {
  slug: string;
}
